import register from './registerSlice';

export * from './registerSlice';

export default register;
